export default "__VITE_PUBLIC_ASSET__40d97c07__"